<label for="dropdown" [ngClass]="{ 'dark-label': isDarkMode() }">
  <span class="asterik-color" *ngIf="required">*</span>{{ label }}
</label>
<div
  class="wrap-select"
  [ngClass]="{ invalid: formSubmitted && controlname?.invalid }"
>
  <select
    class="form-control"
    [formControl]="controlname"
    (change)="onSelectChange($event)"
    [ngClass]="{ 'readonly-select': readonly }"
  >
    <option *ngIf="placeholder" [ngValue]="null" disabled>
  {{ placeholder }}
</option>

   <option
  *ngFor="let item of items; even as isEven; odd as isOdd"
  [ngValue]="item"
  [ngClass]="{ odd: isOdd, even: isEven }"
>
  {{ item }}
</option>

  </select>
</div>

<div *ngIf="formSubmitted && controlname?.invalid" class="error-message">
  <p class="common">{{ requiredErrorMessage }}</p>
</div>
